
// Libraries
import { Component, Vue, Prop } from "nuxt-property-decorator";
import { EsyOilContact } from "~/operations/messages";

// Components
import RouterLink from "~/components/atoms/text/RouterLink.vue";

@Component({
  components: {
    RouterLink,
  },
})
export default class PressContactBoxMolecule extends Vue {
  @Prop({ default: false }) showContactThumbnail: boolean;
  @Prop() thumbnailFigcaption: string;
  @Prop({ default: false }) isReviewSite: boolean;

  EsyOilContact = EsyOilContact;
}
